<template>
  <div class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <el-row class="flex">
        <el-input
          clearable
          v-model="searchName"
          class="w-200px mr-10px"
          size="small"
          placeholder="规则名称"
        ></el-input>
        <el-date-picker
          v-model="datetimerange"
          size="small"
          class="mr-10px"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
        <el-button size="small" type="primary" @click="getDesensitizationRules">搜索</el-button>
        <el-button size="small" @click="clickReset">重置</el-button>
        <el-button
          size="small"
          :disabled="!$hasAccess('create')"
          type="primary"
          @click="clickAddRules"
          >新增</el-button
        >
        <el-button :disabled="!$hasAccess('delete')" size="small" type="danger" @click="clickDelete"
          >删除</el-button
        >
        <el-button
          :disabled="!$hasAccess('export')"
          size="small"
          @click="clickExport"
          :loading="exportLoading"
          >导出</el-button
        >
      </el-row>
      <el-table
        v-loading="tableLoading"
        border
        @selection-change="changeSelected"
        height="calc(100% - 106px)"
        :data="desensitizationList"
        ref="multipleTable"
        class="mt-20px"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip prop="ruleName" label="规则名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="regular" label="替换规则"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="replaceText"
          label="替换字符"
        ></el-table-column>
        <el-table-column show-overflow-tooltip prop="remark" label="备注"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="createdTime"
          label="创建时间"
        ></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              :disabled="!$hasAccess('read')"
              @click.stop="clickView(scope.row)"
              size="mini"
              >{{ $t('view') }}</el-button
            >
            <el-button
              :disabled="!$hasAccess('update')"
              @click.stop="clickEdit(scope.row)"
              size="mini"
              >{{ $t('edit') }}</el-button
            >
            <el-button
              :disabled="!$hasAccess('delete')"
              @click.stop="clickDeleteItem(scope.row)"
              size="mini"
              >{{ $t('delete') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px float-right"
        background
        @current-change="getDesensitizationRules"
        @size-change="getDesensitizationRules"
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        :page-sizes="$pageSizeAll"
        layout="total, sizes, prev, pager, next, jumper"
        :total="recordCount"
      ></el-pagination>

      <el-dialog
        @close="clickCancel"
        :title="dialogTitle"
        class="small-dialog"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        v-dialogDrag
      >
        <el-form
          ref="form"
          :model="ruleFormData"
          :rules="formRules"
          label-width="150px"
          size="small"
        >
          <el-row type="flex" justify="space-between">
            <el-col :span="24">
              <el-form-item prop="ruleName" label="规则名称">
                <el-input
                  maxlength="100"
                  :disabled="disabledOperate"
                  v-model="ruleFormData.ruleName"
                  class="form-content"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="mt-10px" type="flex" justify="space-between">
            <el-col :span="24">
              <el-form-item prop="regular" label="替换规则">
                <el-input
                  maxlength="500"
                  :disabled="disabledOperate"
                  v-model="ruleFormData.regular"
                  :rows="4"
                  type="textarea"
                  class="form-content"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="mt-10px" type="flex" justify="space-between">
            <el-col :span="24">
              <el-form-item prop="replaceType" label="替换方式">
                <el-radio-group
                  :disabled="disabledOperate"
                  @input="activeChangeWay"
                  v-model="ruleFormData.replaceType"
                >
                  <el-radio :label="0" class="!mr-15px">等长替换</el-radio>
                  <el-radio :label="1">固定长度</el-radio>
                </el-radio-group>
                <span>
                  <el-input
                    maxlength="100"
                    v-model="ruleFormData.replaceLength"
                    type="number"
                    :disabled="disableLength"
                    class="!w-120px ml-10px mr-10px"
                  ></el-input
                  >字符
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="mt-10px" type="flex" justify="space-between">
            <el-col :span="24">
              <el-form-item prop="replaceText" label="替换字符">
                <el-input
                  maxlength="100"
                  :disabled="disabledOperate"
                  v-model="ruleFormData.replaceText"
                  class="form-content"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="mt-10px" type="flex" justify="space-between">
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input
                  maxlength="500"
                  :disabled="disabledOperate"
                  v-model="ruleFormData.remark"
                  :rows="4"
                  type="textarea"
                  class="form-content"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div v-if="!disabledOperate" slot="footer" class="dialog-footer tc">
          <el-button size="small" type="primary" @click="confirmOperate">保存</el-button>
          <el-button :disabled="disabledOperate" @click="clickCancel" size="small">取消</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import DesensitizationService from '@/services/Desensitization'
import fnMixin from '@/assets/js/fnMixins'

export default {
  async created() {
    this.activeChangeWay()
    this.getDesensitizationRules()
  },
  updated() {
    this.$nextTick(() => {
      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.doLayout()
      }
    })
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
      recordCount: 0,
      dialogTitle: '新增规则',
      dialogVisible: false,
      ruleFormData: {
        ruleName: '',
        regular: '',
        replaceType: 0,
        replaceText: '',
        replaceLength: 0,
        remark: '',
      },
      exportLoading: false,
      desensitizationList: [],
      tableLoading: false,
      formRules: {
        ruleName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        replaceType: [{ required: true, message: '请输入替换方式', trigger: 'blur' }],
        regular: [{ required: true, message: '请输入替换规则', trigger: 'blur' }],
        replaceText: [{ required: true, message: '请输入替换字符', trigger: 'blur' }],
      },
      searchName: '',
      datetimerange: [],
      disableLength: false,
      disabledOperate: false,
      selectedItems: [],
    }
  },
  methods: {
    /**
     * @function 点击重置
     */
    clickReset() {
      this.searchName = ''
      this.datetimerange = []
      this.getDesensitizationRules()
    },

    /**
     * @function 点击导出
     */
    async clickExport() {
      const ids = _.map(this.selectedItems, (i) => {
        return i.id
      })
      const params = {
        ruleName: this.searchName,
        startDate: this.datetimerange && this.datetimerange[0] ? this.datetimerange[0] : '',
        endDate: this.datetimerange && this.datetimerange[1] ? this.datetimerange[1] : '',
        ids,
      }
      this.exportLoading = true
      const res = await DesensitizationService.exportDesensitization(params)
      this.exportLoading = false
      if (res) {
        const time = fnMixin.methods.getNowTime()
        fnMixin.methods.downLoadExcel(`数据脱敏规则${time}`, res)
      }
    },

    clickDelete() {
      const ids = _.map(this.selectedItems, (i) => {
        return i.id
      })
      if (!ids.length) {
        this.$message({
          type: 'warning',
          message: '请选择要删除的数据',
        })
        return
      }
      this.$confirm('是否确定要删除该数据', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await DesensitizationService.deleteDesensitization(ids)
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '删除成功',
            })
            this.getDesensitizationRules()
          }
        })
        .catch()
    },
    /**
     * @function 点击删除
     */
    clickDeleteItem(item) {
      if (item) {
        this.$confirm('是否确定要删除该数据', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await DesensitizationService.deleteDesensitization([item.id])
            if (res.code === 0) {
              this.$message({
                type: 'success',
                message: '删除成功',
              })
              this.getDesensitizationRules()
            }
          })
          .catch(() => {})
      }
    },

    changeSelected(item) {
      this.selectedItems = item
    },

    /**
     * @function 点击取消
     */
    clickCancel() {
      this.$refs.form.resetFields()
      this.ruleFormData = this.$options.data().ruleFormData
      this.dialogVisible = false
    },

    activeChangeWay() {
      if (this.ruleFormData.replaceType === 1) {
        this.disableLength = false
      } else {
        this.disableLength = true
        this.ruleFormData.replaceLength = 0
      }
    },

    /**
     * @function 点击编辑
     */
    clickEdit(row) {
      this.dialogVisible = true
      this.disabledOperate = false
      this.dialogTitle = '编辑规则'
      this.ruleFormData = _.cloneDeep(row)
    },

    /**
     * @function 获取列表数据
     */
    async getDesensitizationRules() {
      const params = {
        SkipCount: this.pageNo,
        MaxResultCount: this.pageSize,
        Sorting: '',
        RuleName: this.searchName,
        StartDate: this.datetimerange && this.datetimerange[0] ? this.datetimerange[0] : '',
        EndDate: this.datetimerange && this.datetimerange[1] ? this.datetimerange[1] : '',
      }
      this.tableLoading = true
      const res = await DesensitizationService.getList(params)
      this.tableLoading = false
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.desensitizationList = res.data
        this.recordCount = res.totalCount
        this.$nextTick(() => {
          if (this.$refs.multipleTable) {
            this.$refs.multipleTable.doLayout()
          }
        })
      } else {
        this.desensitizationList = []
        this.recordCount = 0
      }
    },

    /**
     * @function 点击新增
     */
    clickAddRules() {
      this.dialogTitle = '新增规则'
      this.disabledOperate = false
      this.dialogVisible = true
    },

    /**
     * @function 点击查看
     */
    clickView(row) {
      this.dialogVisible = true
      this.dialogTitle = '查看规则'
      this.disabledOperate = true
      this.ruleFormData = _.cloneDeep(row)
    },

    /**
     * @function 确定操作
     */
    confirmOperate() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const params = _.cloneDeep(this.ruleFormData)
          if (!this.ruleFormData.replaceLength) {
            delete params.replaceLength
          }
          let res = null
          if (this.dialogTitle === '新增规则') {
            res = await DesensitizationService.createDesensitization(params)
            if (res.code === 0) {
              this.$message({
                type: 'success',
                message: '新增成功',
              })
            }
          } else {
            res = await DesensitizationService.editDesensitization(params)
            if (res.code === 0) {
              this.$message({
                type: 'success',
                message: '编辑成功',
              })
            }
          }
          this.getDesensitizationRules()
          this.clickCancel()
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>

.w-200 {
  width: 200px;
}
.action-btn {
  width: 70px !important;
  height: 40px !important;
}
.form-content {
  width: 800px;
}
.num-input {
  width: 120px;
}
body .el-table th.gutter {
  display: table-cell !important;
}
body .el-table colgroup.gutter {
  display: table-cell !important;
}

</style>
